import Swiper from "swiper/bundle";

export default function DayProducts (){
    let dayProductsContainer = document.querySelector('[data-day-products="container"]');

    if (dayProductsContainer){
        let dayProductsSwiper = document.querySelector('[data-day-products="swiper"]');
        let dayProductsBasketBtn = document.querySelector('[data-day-products="basket-btn"]');

        new Swiper(dayProductsSwiper, {
            modules: [],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 4000,
            },
            pagination: {
                clickable: true,
                el: ".day-products__pagination",
            },
            on:{
                slideChange: function (swiper){
                    let currentSlide = swiper.slides[swiper.activeIndex];

                    if(currentSlide.dataset.basketUrl){
                        dayProductsBasketBtn.setAttribute('href', currentSlide.dataset.basketUrl);
                    }
                    else
                        dayProductsBasketBtn.removeAttribute('href');

                    if(currentSlide.dataset.dayProductId){
                        dayProductsBasketBtn.dataset.productId = currentSlide.dataset.dayProductId;
                        dayProductsBasketBtn.classList.remove("button--disabled");
                    }
                    else{
                        dayProductsBasketBtn.classList.add("button--disabled");
                        delete dayProductsBasketBtn.dataset.productId;
                    }

                    if(currentSlide.dataset.dayProductAction){
                        dayProductsBasketBtn.dataset.basketAction = currentSlide.dataset.dayProductAction;
                    }
                    else
                        delete dayProductsBasketBtn.dataset.basketAction

                    if(currentSlide.dataset.dayProductText){
                        dayProductsBasketBtn.dataset.basketText = currentSlide.dataset.dayProductText;
                    }
                    else
                        delete dayProductsBasketBtn.dataset.basketText
                }
            }
        });
    }
}